// Checking the browser user agent to find if the browser is IE10.
export function getIEVersion() {
    let agent = navigator.userAgent;
    let reg = /MSIE\s?(\d+)(?:\.(\d+))?/i;
    let matches = agent.match(reg);

    if (matches !== null) {
        return matches[1];
    }
    return "-1";
}

export function checkForFatalError(params) {
    if (
        (params.locations.length &&
            !params.markersReference.length &&
            !params.drawRouteFlag &&
            !params.specificLocation) ||
        (!params.locations.length &&
            !params.drawRouteFlag &&
            !params.specificLocation &&
            !params.markersReference.length) ||
        (!params.locations.length && !params.markersReference.length && params.specificLocation)
    ) {
        return { render: false };
    }

    return {
        markersReference: params.markersReference,
        map: params.map,
        directionsDisplayRef: params.directionsDisplayRef,
        infowindowRef: params.infowindowRef,
        render: true
    };
}

export function removeOldMarkers(locations, markersReference) {
    for (let i = 0; i < markersReference.length; i++) {
        let index = locations
            .map(location => {
                return location.location;
            })
            .indexOf(markersReference[i].location);

        if (index === -1) {
            markersReference[i].setMap(null);
            markersReference.slice(1, i);
        }
    }
}

// Compares the new geo location with the already existing markers on the map.
// In addition changes the specific marker property owner(if any).
export function compareNewData(location, markersReference) {
    let index = -1;

    if (typeof location === "string") {
        for (let i = 0; i < markersReference.length; i++) {
            if (location === markersReference[i].location) {
                index = i;
                break;
            }
        }
    } else {
        for (let i = 0; i < markersReference.length; i++) {
            if (
                location.lat === markersReference[i].location.lat &&
                location.lng === markersReference[i].location.lng
            ) {
                index = i;
                break;
            }
        }
    }

    return index === -1;
}

// Checking for duplicate geo locations
export function checkDuplicateLocation(params) {
    if (
        params.drawRouteFlag && // if we are drawing a route
        ((params.directions.waypoints && // we are checking for duplicates in the direction waypoints
            params.directions.waypoints.indexOf(params.location) !== -1) ||
        params.location === params.directions.start || // we are checking for dulicated start location
            params.location === params.directions.end) // we are checking for duplicates in the end location
    ) {
        return true;
    }

    return false;
}
